import React from "react";
import { cn } from "../../lib/utils";

const Badge = React.forwardRef(
  ({ className, variant, ...props }, ref) => {
    const baseClasses = "badge";
    const variantClasses = {
      default: "badge-default",
      secondary: "badge-secondary",
      destructive: "badge-destructive",
      outline: "badge-outline",
      success: "badge-success",
      warning: "badge-warning",
    };

    return (
      <div
        className={cn(baseClasses, variantClasses[variant] || variantClasses.default, className)}
        ref={ref}
        {...props}
      />
    );
  }
);

Badge.displayName = "Badge";

export { Badge };
